module.exports = __webpack_public_path__ + "img/Poland.44cb76c9.jpg";